<div class="wrapper">
  @if (control().value) {
    <div class="file" matTooltip="Reemplazar documento" (click)="onUpload(file)">
      <input type="file" style="display: none" name="file" #file (change)="uploadFile($event)" accept="image/*, .pdf">
      <div class="add-file">
        @if (uploading()) {
          <mat-progress-spinner [mode]="'indeterminate'" [diameter]="40" [strokeWidth]="2"></mat-progress-spinner>
        } @else{
          <i class="fa fa-upload"></i>
        }
      </div>
    </div>
    <div class="file" matTooltip="Descargar documento" (click)="downloadFile(anchor)">
      <a [href]="control().value" target="_blank" #anchor download></a>
      <div class="add-file"><i class="fa fa-download"></i></div>
    </div>
  } @else {
    <div class="file" matTooltip="Subir documento" (click)="onUpload(file)">
      <input type="file" style="display: none" name="file" #file (change)="uploadFile($event)" accept="image/*, .pdf">
      <div class="add-file">
        @if (uploading()) {
          <mat-progress-spinner [mode]="'indeterminate'" [diameter]="40" [strokeWidth]="2"></mat-progress-spinner>
        } @else{
          <i class="fa fa-upload"></i>
        }
      </div>
    </div>
  }
</div>
